import { LandAreaBase } from './base/land-area-base';

export class LandArea extends LandAreaBase { }